import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import { UserModule } from '@/store/modules/user'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyActivityLog',
  setup(__props) {

  const fetchingActivityLogs = ref(false)

  const activityLogs = computed(() => UserModule.activityLogs)

  const backgroundColor = (id: string) => UserModule.groupColorValue(id)?.backgroundColor ?? ''

  const foregroundColor = (id: string) => UserModule.groupColorValue(id)?.foregroundColor ?? ''

  fetchingActivityLogs.value = true
  UserModule.getCompanyActivityLog().then(() => {
    fetchingActivityLogs.value = false
  })

return { __sfc: true,fetchingActivityLogs, activityLogs, backgroundColor, foregroundColor, computed, ref, UserModule, LoadingSpinner }
}

})